import React, { useState, useEffect } from 'react';
import { Button, Col, Container, Row } from "reactstrap";
import { Grid, _ } from 'gridjs-react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

import { useHistory } from 'react-router-dom';
import { deleteGlassType, getAllGlassTypes } from '../../helpers/api/product/product';

const GlassTable = () => {
    const [glasses, setGlasses] = useState([]);

    const history = useHistory();

    document.title = "My Glasses";

    const getGlasss = async () => {
        try {
            setGlasses([]);
            let response = await getAllGlassTypes();
            if (!response.success) throw response.data;

            setGlasses(response.data.map(glass => {
                return [
                    glass.id,
                    glass.GlassName,
                    glass.GlassPicture
                ]
            }));
        } catch (error) {
            console.log(error);
        }
    }

    const handleClickGridItem = (e) => {
        e.preventDefault();
        let row = e.target.parentElement.parentElement.parentElement;
        let id = row.children[0].innerText;

        history.push("/glass-details", { params: { id, type: "INFORM" } });
    }

    const handleAddGlass = () => {
        history.push("/glass-details", { params: { type: "ADD" } });
    }

    const handleClickDelete = async (e) => {
        try {
            e.preventDefault();

            confirmAlert({
                title: 'Confirm to Delete',
                message: 'Are you sure to delete this glass?',
                buttons: [
                    {
                        label: 'Yes',
                        onClick: async () => {
                            let row = e.target.parentElement.parentElement.parentElement;
                            let id = row.children[0].innerText;

                            let response = await deleteGlassType({ id });
                            if (!response.success) return console.log(response.data);

                            await getGlasss();
                        }
                    },
                    {
                        label: 'No'
                    }
                ]
            });
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        getGlasss();
    }, []);

    return (
        <>
            <div className="page-content">
                <Row>
                    <Col xs="10" />
                    <Col xs="2">
                        <Button onClick={handleAddGlass} color="danger">Glass Ekle</Button>
                    </Col>
                </Row>
                <Container fluid={true}>
                    <React.Fragment>
                        <Grid
                            data={glasses}
                            columns={[
                                "#", "Name",
                                {
                                    name: 'Picture',
                                    width: '120px',
                                    formatter: (cell) => _(
                                        <>
                                            {(cell)
                                                ? <img src={cell} alt="main-glass" style={{ width: "100px", height: "100px" }} />
                                                : <></>
                                            }
                                        </>
                                    )
                                },
                                {
                                    name: 'Actions',
                                    width: '120px',
                                    formatter: (cell) => _(
                                        <>
                                            <Button type='button' onClick={handleClickGridItem} className='btn btn-sm btn-light'> Details </Button>
                                            <Button type='button' onClick={handleClickDelete} className='btn btn-sm btn-danger'> Delete </Button>
                                        </>
                                    )
                                }
                            ]}
                            search={true}
                            sort={true}
                            pagination={{ enabled: true, limit: 10 }}
                        />
                    </React.Fragment>
                </Container>
            </div>
        </>
    );
}

export default GlassTable;